import { classes } from "../../react/react";

function getItemsInColumn<T>(items: T[], columns: number, column: number): T[] {
    const size = Math.ceil(items.length / columns);
    const start = column * size;
    const end = Math.min(start + size, items.length);
    return items.slice(start, end);
}

export type RowWithListColumnsProps<T> = {
    /**
     * Additional CSS `className` for the component.
     */
    className?: string;
    /**
     * The items to display.
     */
    items: T[];
    /**
     * The number of columns to split the items across.
     */
    columns: number;
    /**
     * Function to render each item.
     * @param item The item
     * @returns
     */
    renderItem: (item: T) => React.ReactNode;
};

/**
 * Helper component to render items in a list split across `columns` number of columns.
 */
export function RowWithListColumns<T>({ className, items, columns, renderItem }: RowWithListColumnsProps<T>) {
    const colSize = Math.floor(12 / columns);
    return (
        <div className={classes("row", className)}>
            {[...Array(columns).keys()].map((col) => (
                <div key={col} className={`col col-sm-12 col-md-${colSize}`}>
                    <ul>
                        {getItemsInColumn(items, columns, col).map((item, index) => (
                            <li key={index}>{renderItem(item)}</li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}
